export const uniqueValues = <T>(arr1: T[], arr2: T[]) => [...new Set(arr1.concat(arr2))];
